import React, { useState, useEffect } from "react";
import SubscribeModal from "../components/pro/SubscribeModal";
import { useNavigate } from "react-router-dom";
import eventBus from "../utils/eventBus";

const ProPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    eventBus.emit("fullscreen:enter");
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setIsModalOpen(false);
    eventBus.emit("fullscreen:exit");
    // Optional: navigate back to the previous page or home on close
    navigate(-1);
  };

  return (
    <div className="bg-gradient-to-br from-slate-950 via-purple-950 to-slate-900 min-h-screen">
      <SubscribeModal isOpen={isModalOpen} onClose={handleClose} />
    </div>
  );
};

export default ProPage;
